import Icon from "@Components/generic/icon";
import { faMinus } from "@fortawesome/pro-regular-svg-icons";
import { faCircleArrowDown, faCircleArrowUp } from "@fortawesome/pro-solid-svg-icons";
import { Skeleton, Stack, Typography, useTheme } from "@mui/material";
import { isNumber } from "lodash-es";

interface IBybPerformanceDiffLabel {
  diff: number | null;
}

const BybPerformanceDiffLabel = ({ diff }: IBybPerformanceDiffLabel) => {
  const theme = useTheme();

  if (!isNumber(diff)) {
    return <Skeleton variant="rounded" width={70} height={30}></Skeleton>;
  }

  if (!Number.isFinite(diff)) {
    return null;
  }

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        bgcolor: theme.palette[diff > 0 ? "dsSuccess" : diff < 0 ? "dsDestructive" : "dsNeutral"].v100,
        padding: theme.spacing(1),
        borderRadius: theme.spacing(1),
        minWidth: theme.spacing(9),
      }}
    >
      <Icon
        icon={diff > 0 ? faCircleArrowUp : diff < 0 ? faCircleArrowDown : faMinus}
        size="1x"
        color={theme.palette[diff > 0 ? "dsSuccess" : diff < 0 ? "dsDestructive" : "dsNeutral"].v400}
      />
      <Typography
        variant="textS500"
        color={theme.palette[diff > 0 ? "dsSuccess" : diff < 0 ? "dsDestructive" : "dsNeutral"].v400}
        sx={{ textAlign: "center", width: "100%" }}
      >
        {diff.toFixed(1)}%
      </Typography>
    </Stack>
  );
};

export default BybPerformanceDiffLabel;
